import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const GargiSettings = lazy(() => import('../components/GargiSettings'));

const gargiSettingsRoute: RouteObject = {
  path: 'settings/modules/gargi',
  element: <GargiSettings />,
};

export default gargiSettingsRoute;
